module.exports = __webpack_public_path__ + "img/prioritas_interpackmaxi_k.5c99929d.png";